import React from "react"
import { Link } from "gatsby"

const NavFeatureLink = ({ to, title, description }) => (
    <div key={to} className="col-3 feature-category-link m-0">
        <Link to={to} className="category-link">
            <p
                className="feature-highlight__title"
                style={{ lineHeight: "1.6" }}
            >
                {title}
            </p>
        </Link>
        <p
            className="feature-highlight__description"
            style={{ lineHeight: "1.6" }}
        >
            {description}
        </p>
    </div>
)

export default NavFeatureLink